import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { useQuery } from '@tanstack/react-query';

interface Props {
    orderNo: string;
    requestedAt: string;
    paymentAmount: number;
    itemName: string;
    approvalMallId?: string;
    hashString: string;
    returnUrl: string;
}

function usePayU() {
    const { data: payUInfo } = useQuery(queries.easyCard.payU());
    const toast = useToast();
    const addToForm = ({ form, name, value }:{
        form: HTMLFormElement,
        name: string;
        value: string;
    }) => {
        const input = document.createElement('input');
        input.name = name;
        input.value = value;
        form.append(input);
    };

    return (props: Props) => {
        if (!payUInfo) {
            toast.error('간편카드 인증정보가 등록되지 않았습니다.');
            return;
        }
        const {
            orderNo, requestedAt, paymentAmount, itemName, approvalMallId, hashString,
            returnUrl,
        } = props;
        const {
            mid, userId, userName, userPhoneNo, payuInfo,
        } = payUInfo;
        const form = document.createElement('form');
        form.target = '_self';
        form.acceptCharset = 'euc-kr';
        form.action = import.meta.env.VITE_PAY_U_REQUEST_URL;
        form.method = 'POST';
        form.hidden = true;
        addToForm({ form, name: 'MallUserID', value: userId });
        addToForm({ form, name: 'MID', value: mid });
        addToForm({ form, name: 'BuyerName', value: userName });
        addToForm({ form, name: 'BuyerTel', value: userPhoneNo });
        addToForm({ form, name: 'BuyerEmail', value: '' });
        addToForm({ form, name: 'CharSet', value: 'euc-kr' });

        addToForm({ form, name: 'AuthType', value: '2' });
        addToForm({ form, name: 'Moid', value: orderNo });
        addToForm({ form, name: 'EdiDate', value: requestedAt });
        addToForm({ form, name: 'Amt', value: paymentAmount.toString() });
        addToForm({ form, name: 'GoodsName', value: itemName });

        if (mid !== approvalMallId && approvalMallId) {
            addToForm({ form, name: 'ApprovalMID', value: approvalMallId });
        }
        addToForm({ form, name: 'ReturnUrl', value: returnUrl });

        addToForm({ form, name: 'RcvName', value: userName });
        addToForm({ form, name: 'RctTel', value: userPhoneNo });
        addToForm({ form, name: 'RcvPostNo', value: '04781' });
        addToForm({ form, name: 'RcvAddr1', value: '경기도 성남시' });
        addToForm({ form, name: 'RcvAddr2', value: '이매동' });

        addToForm({ form, name: 'SignData', value: hashString });

        if (payuInfo) {
            addToForm({ form, name: 'UserKey', value: payuInfo.userKey });
        }

        document.body.append(form);
        form.submit();
    };
}

export default usePayU;
